import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { ConsentCheckbox } from '../elements/ConsentCheckbox';
import { PhoneNumberInput } from '../elements/PhoneNumberInput';
import { SelectDropdown } from '../elements/SelectDropdown';
import { SubmitButton } from '../elements/SubmitButton';
import { TextArea } from '../elements/TextArea';
import { TextInput } from '../elements/TextInput';
import type { FormValues, MetaValues } from '@/types/form';
import { useMutation } from '@tanstack/react-query';
import { getSubmitFormValues } from '../lib/getFormFormatedValues';
import { submitForm } from '../lib/submitForm';
import type { AstroLocale } from '@/schemas/components/shared/i18n';

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldComponents: {
    ConsentCheckbox,
    PhoneNumberInput,
    SelectDropdown,
    TextArea,
    TextInput,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
});

export const useContactFormQuery = (
  language: AstroLocale,
  thankYouPage: string,
) => {
  const chiliPiperTenandId =
    import.meta.env.PUBLIC_CHILLI_PIPER_TENANT_ID || 'safeguardglobal';
  const chiliPiperRouterName =
    import.meta.env.PUBLIC_CHILLI_PIPER_ROUTER_NAME || 'dev-us-canada-router';

  return useMutation({
    mutationFn: ({ value, meta }: { value: FormValues; meta: MetaValues }) =>
      submitForm(value, meta, language === 'zh'),
    onSuccess: (_, params) => {
      if (window?.ChiliPiper && language !== 'zh') {
        const leadValues = getSubmitFormValues(params.value, params.meta);
        window.ChiliPiper.submit(chiliPiperTenandId, chiliPiperRouterName, {
          map: true,
          lead: leadValues,
          onSuccess: () => {
            window.location.assign(`${window.location.origin}${thankYouPage}`);
          },
          onClose: () => {
            window.location.assign(`${window.location.origin}${thankYouPage}`);
          },
        });
        return;
      }
      window.location.assign(`${window.location.origin}${thankYouPage}`);
    },
  });
};
